<template>
  <div class="navbarComponent order-view-navbar">
    <div class="container-sm">
      <div class="inside">
        <div class="case-status">
          <div class="order-header-bar">
            <div
              class="order-header-left"
              v-if="(!isCaseCompleted && hasPermission('orders', 'edit')) || (getCaseInformation && getCaseInformation.emr_issues && getCaseInformation.emr_issues.length)"
            >
              <ul v-if="!isCaseCompleted && hasPermission('orders', 'edit')">
                <li>
                  <el-button class="btn-delete" @click="goToEditForm">
                    <span class="pr-5">EDIT</span>
                  </el-button>
                </li>
                <li v-if="isSampleReviewPending">
                  <el-button class="btn-review-sample" @click="openSampleApprovalDialog">
                    <span class="pr-5">Review Sample</span>
                  </el-button>
                </li>
              </ul>
              <div v-if="getCaseInformation && getCaseInformation.emr_issues && getCaseInformation.emr_issues.length && getCaseInformation.status !== 'COMPLETED' && getCaseInformation.status !== 'PARTIAL'" class="emr-issues-inline">
                <span v-for="issue in getCaseInformation.emr_issues" :key="issue.key" class="emr-issue-tag">
                  <i class="el-icon-warning"></i> {{ issue.message }}
                </span>
              </div>
            </div>
            <div class="order-header-accessions" v-if="hasAccessionInfo">
              <h3 class="name">Accession Id</h3>
              <div class="accession-list">
                <el-button
                  v-for="(item, index) of getCaseInformation.accession_data"
                  :key="item.case_id || index"
                  class="btn-success accession-btn"
                  @click="goToCaseView(item.case_id)"
                >
                  {{ item.accession_id }}
                </el-button>
              </div>
            </div>
            <div class="order-header-right">
              <ul
                class="justify-content-end"
                v-if="getCaseInformation && getCaseInformation.status"
              >
                <li>
                  <h3 class="name">Order Status</h3>
                </li>
                <li>
                  <div
                    class="column-status"
                    v-if="
                      hasPermission('orders', 'pending_rejection') &&
                      getCaseInformation?.status
                    "
                  >
                    <div v-if="canChangeStatus">
                      <el-dropdown
                        class="status-dropdown"
                        :disabled="
                          getCaseInformation.status === 'COMPLETED' ||
                          getCaseInformation.status === 'PARTIAL'
                        "
                        @command="handleStatusChange"
                        trigger="hover"
                        v-if="hasPermission('orders', 'update_status')"
                      >
                        <span class="el-dropdown-link">
                          <el-tag :type="statusTagType" style="cursor: pointer">
                            {{ formattedStatusText }}
                          </el-tag>
                        </span>
                        <template #dropdown>
                          <el-dropdown-menu
                            class="status-dropdown-menu center-dropdown"
                          >
                            <span v-if="showActiveOption">
                              <el-dropdown-item
                                command="ACTIVE"
                                :disabled="
                                  getCaseInformation.status === 'ACTIVE'
                                "
                              >
                                ACTIVE
                              </el-dropdown-item>
                            </span>
                            <el-dropdown-item
                              v-if="getCaseInformation.status !== 'PARTIALLY_REJECTED'"
                              command="PENDING"
                              :disabled="
                                getCaseInformation.status === 'PENDING'
                              "
                            >
                              PENDING
                            </el-dropdown-item>
                            <el-dropdown-item
                              command="REJECTED"
                              :disabled="
                                getCaseInformation.status === 'REJECTED'
                              "
                            >
                              REJECTED
                            </el-dropdown-item>
                          </el-dropdown-menu>
                        </template>
                      </el-dropdown>
                    </div>
                    <div v-else>
                      <el-tag :type="statusTagType" style="cursor: not-allowed">
                        {{ formattedStatusText }}
                      </el-tag>
                    </div>
                  </div>

                  <div v-else class="column-status">
                    <el-tag :type="statusTagType">
                      {{ formattedStatusText }}
                    </el-tag>
                  </div>
                </li>
                <li v-if="getCaseInformation && getCaseInformation.sent_to_mlx">
                  <el-tooltip content="Sent to MLX" placement="top">
                    <img
                      style="height: 20px; width: 20px"
                      src="@/assets/images/icons/actions/mlx-icon.png"
                      alt="sent-to-mlx"
                    />
                  </el-tooltip>
                </li>
                <li v-if="hasPermission('generate_order_barcode', 'view')">
                  <el-button
                    class="pr-5"
                    id="generate-barcode-button"
                    @click="viewBarcode"
                  >
                    PRINT BARCODE
                  </el-button>
                </li>
                <li v-if="hasPermission('cases', 'create')">
                  <el-button class="pr-5" @click="viewOrderAudit">
                    Audit
                  </el-button>
                </li>
                <li v-if="getPendingOrderLogs && getPendingOrderLogs.length">
                  <el-button
                    @click="drawer = true"
                    class="btn button-with-icon with-blue-bg mini-btn"
                  >
                    Client Response
                  </el-button>
                </li>
                <el-drawer
                  v-model="drawer"
                  title="I am the title"
                  :with-header="false"
                  v-if="drawer"
                >
                  <div class="drawercloseheader">
                    <el-button @click="closeDrawer" class="drawerclose">
                      <img
                        src="@/assets/images/icons/cases/close-btn.svg"
                        alt="icon"
                        width="30"
                      />
                    </el-button>
                  </div>
                </el-drawer>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <section
    class="new-case-view case-creation"
    id="single-case-view"
    v-loading="loading"
  >
    <div
      class="sample-pending-banner"
      v-if="isSampleReviewPending"
    >
      <div class="container-sm">
        <div class="sample-pending-alert">
          <i class="el-icon-warning"></i>
          <span>Under Sample Approval &mdash; Unable to create accession until sample approval is completed.</span>
        </div>
      </div>
    </div>
    <div
      class="previously-collected-banner"
      v-if="hasPendingSampleData"
    >
      <div class="container-sm">
        <div class="previously-collected-card">
          <div class="previously-collected-header">
            <i class="el-icon-warning"></i>
            <div class="previously-collected-heading">
              <h4>Previously Collected Samples</h4>
              <span>Patient had samples collected within the last 3 days</span>
            </div>
          </div>
          <table class="previously-collected-table">
            <thead>
              <tr>
                <th>Order ID</th>
                <th>Tube Names</th>
                <th>Collection Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="sample in getCaseInformation.sample_pending_data"
                :key="sample._id || sample.order_id"
              >
                <td>{{ sample.order_id }}</td>
                <td>
                  <span
                    v-for="(tube, tIndex) in sample.tube_names"
                    :key="`${sample._id}-tube-${tIndex}`"
                    class="tube-chip-item"
                  >
                    <span class="tube-chip">{{ tube }}</span>
                    <span
                      v-if="getTubeAccession(sample, tube)"
                      class="tube-accession-info"
                    >
                      {{ getTubeAccession(sample, tube).accession }}<template v-if="getTubeAccession(sample, tube).lab"> &middot; {{ getTubeAccession(sample, tube).lab }}</template>
                    </span>
                  </span>
                </td>
                <td>{{ momentWithTimezone(sample.collection_date) }}</td>
                <td>
                  <el-button
                    class="view-order-btn"
                    size="small"
                    @click="goToPreviousOrderView(sample.order_id)"
                  >
                    View Order
                  </el-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div
      class="order-status-reason"
      v-if="getCaseInformation?.reasons?.length && getCaseInformation?.notes"
    >
      <div class="container-sm">
        <div class="bg-white">
          <ul>
            <li>
              <h4 class="reason-heading">Reasons :</h4>
            </li>
            <li
              v-for="(reason, index) in getCaseInformation.reasons"
              :key="`reason-${index}-${reason}`"
            >
              <p>{{ reason }}</p>
            </li>
          </ul>
          <ul>
            <li>
              <h4 class="reason-heading">Notes :</h4>
            </li>
            <li>
              <p>{{ getCaseInformation.notes }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="case-view-body">
      <div class="container-sm">
        <section id="view-case-screen">
          <div
            class="hospital-dataentry-comment"
            v-if="
              getCaseInformation?.hospital?.dataentry_comment &&
              getCaseInformation.hospital.dataentry_comment.length > 0
            "
          >
            <h4 class="hospital-dataentry-comment__title">
              Data Entry Comment: {{ getCaseInformation.hospital.dataentry_comment }}
            </h4>
          </div>
          <PatientInformation></PatientInformation>
          <span class="case-creation__divider"></span>

          <CaseInformation></CaseInformation>
          <span class="case-creation__divider"></span>
          <Medication
            v-if="getCaseInformation?.case_types?.includes('TOXICOLOGY')"
          ></Medication>
          <div v-if="$route.query.isOldOrder !== 'true'">
            <TestInformation />
          </div>
          <span
            class="case-creation__divider"
            v-if="isCaseHavingAdditionalNotes"
          ></span>
          <AdditionalNotes v-if="isCaseHavingAdditionalNotes"></AdditionalNotes>
          <span
            class="case-creation__divider"
            v-if="isCaseHavingAdditionalNotes"
          ></span>

          <span class="case-creation__divider"></span>
          <BillingInformation v-if="hasBillingType"></BillingInformation>
          <span class="case-creation__divider" v-if="hasBillingType"></span>

          <TestAttachments></TestAttachments>
          <span
            class="case-creation__divider"
            v-if="!getAuthenticatedUser?.allow_unathorized_access"
          ></span>
          <ErequisitionForm
          ></ErequisitionForm>
          <span
            class="case-creation__divider"
            v-if="!getAuthenticatedUser?.allow_unathorized_access"
          ></span>
            <LabsquireTestTubesInfo
              @update-tube-info="handleTubeInfoUpdate"
              @ack-pending-confirmation="handleAckPendingConfirmation"
            ></LabsquireTestTubesInfo>

            <span class="case-creation__divider" v-if="checkCaseStatus"></span>
          
          <div
            v-if="getCaseInformation && getCaseInformation.collected_order && getCaseInformation.collected_tubes && getCaseInformation.collected_tubes.length"
            class="collected-tubes-section"
          >
            <div class="collected-section-header">
              <div class="collected-section-title">
                <img src="@/assets/images/icons/actions/mlx-icon.png" alt="phlebio" class="phlebio-icon" />
                SAMPLES COLLECTED
              </div>
              <div class="collected-meta">
                <span v-if="getCaseInformation.fasting" class="meta-chip fasting">Fasting</span>
                <span v-if="getCaseInformation.technician_name" class="meta-chip technician">
                  Technician Name: <strong>{{ getCaseInformation.technician_name }}</strong>
                </span>
              </div>
            </div>

            <div class="collected-tubes-grid">
              <div
                v-for="tube in getCaseInformation.collected_tubes"
                :key="tube.tube_name"
                class="tube-card"
              >
                <div class="tube-count">{{ tube.tube_count }}</div>
                <div class="tube-label">{{ tube.tube_name }}</div>
              </div>
            </div>

            <div v-if="getCaseInformation.collected_tests && getCaseInformation.collected_tests.length" class="collected-tests-row">
              <span class="collected-tests-label">Collected Tests</span>
              <div class="collected-tests-list">
                <span
                  v-for="test in getCaseInformation.collected_tests"
                  :key="test"
                  class="collected-test-chip"
                >{{ test }}</span>
              </div>
            </div>
          </div>

          <span
            v-if="getCaseInformation && getCaseInformation.collected_order && getCaseInformation.collected_tubes && getCaseInformation.collected_tubes.length"
            class="case-creation__divider"
          ></span>

          <CreateAccession
            v-if="checkCaseStatus"
            :tubeInformationFromChild="tubeInformationFromChild"
            :ackPendingConfirmation="ackPendingConfirmation"
            @update-refetch-test-info="handleRefetchTestInfo"
            :refetch-test-info="refetchTestInfo"
          ></CreateAccession>
          <span class="case-creation__divider" v-if="checkCaseStatus"></span>
        </section>
      </div>
    </div>
    <AuditLogs
      v-if="orderAuditLogsPopup"
      v-on:close="orderAuditLogsPopup = false"
      :orderId="orderId"
    ></AuditLogs>
    <ResonForChange
      v-if="takeReasonDialog"
      v-on:close="takeReasonDialog = false"
      v-on:reasonSubmit="deleteCase"
      title="Reason for Archive"
    ></ResonForChange>
    <ReasonForStatusChange
      v-if="takeStatusChangeReasonDialog"
      v-on:close="takeStatusChangeReasonDialog = false"
      v-on:reasonSubmit="unsetOrderCompleteStatus"
      :width="40"
      :title="takeStatusChangeReasonDialogTitle"
    ></ReasonForStatusChange>
    <OrderRejectDialog
      v-if="orderRejectDialogVisible"
      :visible="orderRejectDialogVisible"
      :orderData="orderRejectRow"
      :tubeInfo="orderRejectTubeInfo"
      :loading="orderRejectLoading"
      :submitting="orderRejectSubmitting"
      :mode="orderRejectMode"
      @close="closeOrderRejectDialog"
      @submit="submitOrderReject"
    />
    <OptionsRejectPopup
      :visible="showRejectOptionsPopup"
      :mode="rejectOptionsMode"
      @close="closeRejectOptionsPopup"
      @partial="onPartialRejectOption"
      @complete="onCompleteRejectOption"
      @activate="onPartialActivateOption"
    />
    <SampleApprovalDialog
      v-if="sampleApprovalDialogVisible"
      :visible="sampleApprovalDialogVisible"
      :orderId="getCaseInformation && getCaseInformation.order_id"
      :existingOrders="(getCaseInformation && getCaseInformation.sample_pending_data) || []"
      :submitting="sampleApprovalSubmitting"
      @close="closeSampleApprovalDialog"
      @submit="submitSampleApproval"
    />
  </section>
</template>

<script>
import { defineAsyncComponent } from "vue";
import OptionsRejectPopup from "@/components/cases/OptionsRejectPopup.vue";
const OrderRejectDialog = defineAsyncComponent(() =>
  import("@/components/orders/OrderRejectDialog")
);
const TestInformation = defineAsyncComponent(() =>
  import("@/components/orders/ViewTests")
);
const PatientInformation = defineAsyncComponent(() =>
  import("@/components/orders/PatientInformations")
);
const CaseInformation = defineAsyncComponent(() =>
  import("@/components/orders/CaseInformations")
);
const Medication = defineAsyncComponent(() =>
  import("@/components/orders/MedicationView")
);
const BillingInformation = defineAsyncComponent(() =>
  import("@/components/orders/BillingInformations")
);
const TestAttachments = defineAsyncComponent(() =>
  import("@/components/orders/TestAttachments")
);
const CreateAccession = defineAsyncComponent(() =>
  import("@/components/orders/CreateAccession")
);
const ErequisitionForm = defineAsyncComponent(() =>
  import("@/components/orders/Erequisition")
);
const ResonForChange = defineAsyncComponent(() =>
  import("@/components/misc/ResonForChange")
);
const SampleApprovalDialog = defineAsyncComponent(() =>
  import("@/components/orders/SampleApprovalDialog")
);
const ReasonForStatusChange = defineAsyncComponent(() =>
  import("@/components/misc/OrderReasonForChange")
);
import { mapGetters } from "vuex";
import caseConstants from "@/config/constants/caseConstants";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import AuditLogs from "@/components/cases/AllLogs";
import LabsquireTestTubesInfo from "../../components/orders/LabsquireTestTubesInfo.vue";
const AdditionalNotes = defineAsyncComponent(() =>
  import("@/components/orders/AdditionalNotes")
);
export default {
  inheritAttrs: false, // Prevent layout prop from being inherited
  components: {
    TestInformation,
    PatientInformation,
    CaseInformation,
    Medication,
    BillingInformation,
    TestAttachments,
    CreateAccession,
    ErequisitionForm,
    AuditLogs,
    AdditionalNotes,
    ResonForChange,
    ReasonForStatusChange,
    LabsquireTestTubesInfo,
    OrderRejectDialog,
    OptionsRejectPopup,
    SampleApprovalDialog,
  },
  data() {
    return {
      scrollPosition: null,
      loading: false,
      orderAuditLogsPopup: false,
      drawer: false,
      takeReasonDialog: false,
      takeStatusChangeReasonDialog: false,
      takeStatusChangeReasonDialogTitle: "",
      tubeInformationFromChild: [],
      refetchTestInfo: false,
      ackPendingConfirmation: false,
      unsetCompleteStatusChangeCase: null,
      toStatus: null,
      orderId: null,
      scrollHandler: null, // Store debounced handler for cleanup
      orderRejectDialogVisible: false,
      orderRejectRow: {},
      orderRejectTubeInfo: [],
      orderRejectMode: "reject",
      orderRejectLoading: false,
      orderRejectSubmitting: false,
      showRejectOptionsPopup: false,
      rejectOptionsMode: "reject",
      rejectOptionsContext: { row: null },
      sampleApprovalDialogVisible: false,
      sampleApprovalSubmitting: false,
    };
  },
  
  mixins: [UserPermissionsHelper],
  watch: {
    "$route.params.order_id"() {
      this.orderId = this.$route.params.order_id;
      this.fetchOrderInformation();
    },
  },
  computed: {
    ...mapGetters("auth", ["getAuthenticatedUser"]),
    ...mapGetters("orders", [
      "getCaseInformation",
      "getShowMedication",
      "getUpdateOrderStatus",
      "getScanOrderDetails",
    ]),
    checkCaseStatus() {
      if (!this.getCaseInformation) return false;
      const status = this.getCaseInformation.status;
      const excludedStatuses = ["COMPLETE", "COMPLETED", "ARCHIVED", "REJECTED"];
      if (excludedStatuses.includes(status)) return false;
      // Hide accession for EMR orders sent to MLX without collected tests
      if (
        [caseConstants.ORDER_TYPES.EMR, caseConstants.ORDER_TYPES.TESTGO, caseConstants.ORDER_TYPES.MRYODA].includes(this.getCaseInformation.order_type) &&
        this.getCaseInformation.sent_to_mlx &&
        (!this.getCaseInformation.collected_tests || !this.getCaseInformation.collected_tests.length)
      ) {
        return false;
      }
      return true;
    },
    isCaseCompleted() {
      if (!this.getCaseInformation) {
        return false;
      }
      return this.getCaseInformation.status === "COMPLETED";
    },
    hasBillingType() {
      return this.getCaseInformation?.billing_type === "INSURANCE";
    },
    isCaseHavingAdditionalNotes() {
      return !!this.getCaseInformation?.physician_notes;
    },
    // Sample review applies only to pending orders that are not already rejected.
    isSampleReviewPending() {
      return !!(
        this.getCaseInformation &&
        this.getCaseInformation.sample_pending &&
        this.getCaseInformation.status !== "REJECTED"
      );
    },
    hasPendingSampleData() {
      return !!(
        this.isSampleReviewPending &&
        this.getCaseInformation.sample_pending_data &&
        this.getCaseInformation.sample_pending_data.length
      );
    },
    getStatusType() {
      return (statusVal) => {
        const status = statusVal?.trim();
        const statusMap = {
          ACTIVE: "",
          COMPLETED: "success",
          TEST_REPORTS: "warning",
          TEST_RESULTS: "info",
          ARCHIVED: "danger",
          REJECTED: "darkDanger",
          PARTIALLY_REJECTED: "darkDanger",
          PENDING: "danger",
        };
        return statusMap[status] || "";
      };
    },
    // Memoized status text to avoid repeated string operations
    formattedStatusText() {
      if (!this.getCaseInformation?.status) return "";
      const status = this.getCaseInformation.status;
      if (status === "COMPLETED") return "COMPLETED";
      if (status === "PARTIAL") return "PARTIAL";
      return status.split("_").join(" ");
    },
    // Memoized status type for the tag
    statusTagType() {
      if (!this.getCaseInformation?.status) return "";
      return this.getStatusType(this.getCaseInformation.status);
    },
    // Pre-computed values for template
    hasAccessionInfo() {
      return (
        this.getCaseInformation &&
        this.getCaseInformation.accession_data &&
        this.getCaseInformation.accession_data.length
      );
    },
    canChangeStatus() {
      return (
        this.hasPermission("orders", "pending_rejection") &&
        this.getCaseInformation?.status &&
        this.getCaseInformation.status !== "COMPLETED" &&
        this.getCaseInformation.status !== "ARCHIVED" &&
        this.getCaseInformation.status !== "PARTIAL"
      );
    },
    showActiveOption() {
      const status = this.getCaseInformation?.status;
      return status === "REJECTED" || status === "PENDING" || status === "PARTIALLY_REJECTED";
    },
  },
  async mounted() {
    this.orderId = this.$route.params.order_id;
    // Add Class
    this.toggleBodyClass("addClass", "fixedNavbarBody");
    // Debounce scroll handler for better performance
    this.scrollHandler = this.debounce(this.updateScroll, 10);
    window.addEventListener("scroll", this.scrollHandler, { passive: true });
    // Load data
    await this.fetchOrderInformation();
    if (this.$route.query?.drawer) {
      this.drawer = true;
    }
  },
  beforeUnmount() {
    // Remove Class to body on scroll
    document.body.classList.remove("fixedNavbarOnComponent");
    document.body.classList.remove("fixedNavbarBody");
    // Remove event listener with the stored handler
    if (this.scrollHandler) {
      window.removeEventListener("scroll", this.scrollHandler);
    }
  },
  methods: {
    handleTubeInfoUpdate(updatedData) {
      this.tubeInformationFromChild = updatedData;
    },
    handleAckPendingConfirmation(isPending) {
      this.ackPendingConfirmation = isPending;
    },
    async handleRefetchTestInfo(value) {
      this.refetchTestInfo = value;
      // A child (e.g. CreateAccession) reported the order changed — reload the
      // order information so the page reflects the new state instead of stale data.
      if (value) {
        await this.fetchOrderInformation();
        this.refetchTestInfo = false;
      }
    },
    async updateViewOrder(resp) {
      if (resp) {
        await this.fetchOrderInformation();
      }
    },
    viewOrderAudit() {
      this.orderAuditLogsPopup = true;
    },
    goToEditForm() {
      this.$router.push({
        name: "Edit-Order-Info",
        params: { order_id: this.$route.params.order_id },
        query: this.$route.query,
      });
    },
    goToCaseView(case_id) {
      this.$router.push({
        name: "CaseView",
        params: { case_id: case_id },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    async goToPreviousOrderView(orderId) {
      if (!orderId) return;
      try {
        await this.$store.dispatch("orders/fetchScanOrderById", {
          orderId,
        });
        if (this.getScanOrderDetails?._id) {
          this.$router.push({
            name: "Order-Information",
            params: { order_id: this.getScanOrderDetails._id },
            query: { ...this.$route.query, redirectRoute: this.$route.name },
          });
        } else {
          this.$notify({
            type: "error",
            title: "Error",
            message: "Order not found",
          });
        }
      } catch (error) {
        console.error("Error fetching order by order id:", error);
      }
    },
    getTubeAccession(sample, tube) {
      return sample?.tube_accession?.[tube] || null;
    },
    openSampleApprovalDialog() {
      this.sampleApprovalDialogVisible = true;
    },
    closeSampleApprovalDialog() {
      this.sampleApprovalDialogVisible = false;
    },
    async submitSampleApproval({ action, payload }) {
      try {
        this.sampleApprovalSubmitting = true;
        await this.$store.dispatch("orders/reviewSampleApproval", {
          order_id: this.$route.params.order_id,
          payload,
        });
        this.$notify({
          type: "success",
          title: "Success",
          message:
            action === "reject"
              ? "Sample rejected successfully"
              : "Sample approved successfully",
        });
        this.sampleApprovalDialogVisible = false;
        await this.fetchOrderInformation();
      } catch (error) {
        this.$notify({
          type: "error",
          title: "Error",
          message:
            error?.response?.data?.message || "Failed to submit sample review",
        });
      } finally {
        this.sampleApprovalSubmitting = false;
      }
    },
    updateScroll() {
      this.scrollPosition = window.scrollY;
    },
    // Debounce utility function
    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    },
    // Optimized status change handler
    handleStatusChange(command) {
      this.changeStatus(command, this.getCaseInformation);
    },
    async openOrderRejectDialog(row, mode = "reject") {
      this.orderRejectRow = row;
      this.orderRejectTubeInfo = [];
      this.orderRejectMode = mode;
      this.orderRejectDialogVisible = true;
      this.orderRejectLoading = true;

      try {
        const tubeInfoMap = await this.$store.dispatch(
          "orders/fetchOrderTestsTubeInfoBulk",
          { ids: [row._id], includeRejected: mode === "activate" }
        );
        this.orderRejectTubeInfo = JSON.parse(
          JSON.stringify(tubeInfoMap[row._id] || [])
        );
      } catch (error) {
        console.error("Unable to load order tube information:", error);
        this.$notify({
          type: "error",
          title: "Error",
          message: "Unable to load order tube information",
        });
      } finally {
        this.orderRejectLoading = false;
      }
    },
    closeOrderRejectDialog() {
      this.orderRejectDialogVisible = false;
      this.orderRejectRow = {};
      this.orderRejectTubeInfo = [];
      this.orderRejectMode = "reject";
    },
    async submitOrderReject(payload) {
      try {
        this.orderRejectSubmitting = true;
        const isActivation = this.orderRejectMode === "activate";
        const result = await this.$store.dispatch(
          isActivation ? "orders/partialActivateOrder" : "orders/rejectOrder",
          payload
        );

        if (result && result.success !== false) {
          this.$notify({
            type: "success",
            title: "Success",
            message: result.message || (isActivation
              ? "Order activated successfully"
              : "Order rejection submitted successfully"),
          });
          this.closeOrderRejectDialog();
          await this.fetchOrderInformation();
        } else {
          this.$notify({
            type: "error",
            title: "Error",
            message: result?.message || "Unable to update order status",
          });
          this.closeOrderRejectDialog();
        }
      } catch (error) {
        console.error("Error submitting order rejection:", error);
        this.$notify({
          type: "error",
          title: "Error",
          message: error.response?.data?.message || error.message || "Unable to update order status",
        });
        this.closeOrderRejectDialog();
      } finally {
        this.orderRejectSubmitting = false;
      }
    },
    async onPartialRejectOption() {
      const row = this.rejectOptionsContext.row;
      this.closeRejectOptionsPopup();
      if (row) {
        await this.openOrderRejectDialog(row);
      }
    },
    async onPartialActivateOption() {
      const row = this.rejectOptionsContext.row;
      this.closeRejectOptionsPopup();
      if (row) {
        await this.openOrderRejectDialog(row, "activate");
      }
    },
    async onCompleteRejectOption() {
      const row = this.rejectOptionsContext.row;
      this.closeRejectOptionsPopup();
      if (row) {
        this.unsetCompleteStatusChangeCase = row._id;
        this.toStatus = "REJECTED";
        this.takeStatusChangeReasonDialogTitle = "Reason for Rejection";
        this.takeStatusChangeReasonDialog = true;
      }
    },
    closeRejectOptionsPopup() {
      this.showRejectOptionsPopup = false;
      this.rejectOptionsContext = { row: null };
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    async fetchOrderInformation() {
      try {
        this.loading = true;
        let oldOrderId =
          this.$route.query?.isOldOrder === "true" ? true : false;
        await this.$store.dispatch("orders/fetchCaseInformation", {
          order_id: this.$route.params.order_id,
          isOldOrder: oldOrderId,
        });
      } catch (error) {
        console.error("Error fetching order information:", error);
        this.$notify({
          type: "error",
          title: "Error",
          message: "Failed to load order information",
        });
      } finally {
        this.loading = false;
      }
    },
    closeDrawer() {
      this.drawer = false;
      const query = { ...this.$route.query };
      delete query.drawer;
      this.$router.push({ query });
    },
    viewBarcode() {
      const urlData = this.$router.resolve({
        name: "OrderMultipleBarcodes",
        path: "/orders/multiple-barcodes",
        query: {
          order_ids: this.orderId,
        },
      });
      window.open(urlData.href, "_blank");
    },
    async changeStatus(command, OrderData) {
      try {
        if (command === OrderData.status) {
          return;
        }

        if (command === "REJECTED") {
          if (OrderData.status === "PARTIAL") {
            await this.openOrderRejectDialog(OrderData);
            return;
          }

          if (OrderData.status === "ACTIVE" || OrderData.status === "PARTIALLY_REJECTED") {
            this.rejectOptionsContext = { row: OrderData };
            this.rejectOptionsMode = "reject";
            this.showRejectOptionsPopup = true;
            return;
          }
        }

        if (command === "ACTIVE" && OrderData.status === "PARTIALLY_REJECTED") {
          await this.openOrderRejectDialog(OrderData, "activate");
          return;
        }

        this.takeStatusChangeReasonDialogTitle = command;
        const params = {
          status: command,
          id: OrderData._id,
        };
        if (
          OrderData.status === "ACTIVE" ||
          OrderData.status === "PENDING" ||
          OrderData.status === "REJECTED"
        ) {
          this.unsetCompleteStatusChangeCase = OrderData._id;
          this.toStatus = command;
          this.askReasonOnUnsetCompletedStatus();
        } else {
          await this.updateStatus(params);
        }
      } catch (err) {
        console.error("Error changing status:", err);
        this.$notify({
          type: "error",
          title: "Error",
          message: "Failed to change order status",
        });
      }
    },
    async unsetOrderCompleteStatus(data) {
      let params = {
        id: this.unsetCompleteStatusChangeCase,
        status: this.toStatus,
        notes: data.notes,
      };
      if (data.reasons && data.reasons.length > 0) {
        params.reasons = data.reasons;
      }
      if (data.image) {
        const formData = new FormData();
        formData.append("status", params.status);
        if (params.notes) formData.append("notes", params.notes);
        if (params.reasons && params.reasons.length > 0) {
          formData.append("reasons", JSON.stringify(params.reasons));
        }
        formData.append("image", data.image);
        params = { id: params.id, formData };
      }
      await this.updateStatus(params);
    },
    askReasonOnUnsetCompletedStatus() {
      this.takeStatusChangeReasonDialog = true;
    },
    async updateStatus(params) {
      try {
        this.loading = true;
        await this.$store.dispatch("orders/changeOrderStatus", params, {
          root: true,
        });
        if (this.getUpdateOrderStatus?.success) {
          this.$notify({
            type: "success",
            title: "Success",
            message: this.getUpdateOrderStatus.message,
          });
          // Refetch order information instead of reloading the page
          await this.fetchOrderInformation();
        }
      } catch (err) {
        console.error("Error updating status:", err);
        this.$notify({
          type: "error",
          title: "Error",
          message: "Failed to update order status",
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss">
#generate-barcode-button {
  background: linear-gradient(79.26deg, #f24a55 -13.43%, #0a5da6 137.71%);
  color: white;
  border-radius: 7px;
  padding: 6px 20px;
  border: none;
  font-weight: 600;
}
.case-view-body {
  .hospital-dataentry-comment {
    background: #fff8e6;
    border: 1px solid #f6dc9c;
    border-left: 4px solid #f2b632;
    border-radius: 6px;
    padding: 12px 14px;
    margin-bottom: 10px;

    .hospital-dataentry-comment__title {
      margin: 0 0 4px;
      color: #8a5a00;
      font-size: 13px;
      font-weight: 700;
      text-transform: uppercase;
    }

    .hospital-dataentry-comment__text {
      margin: 0;
      color: #5c4a21;
      font-size: 13px;
      line-height: 1.5;
      white-space: pre-wrap;
      word-break: break-word;
    }
  }

  .view-cases {
    &.search-btn {
      ul {
        padding-bottom: 10px;
        li {
          .search-with-filter-input {
            position: relative;
            .el-select {
              .el-input__inner {
                cursor: pointer;
                display: inline-flex;
                height: 35px;
                background: #ffffff;
                border: 1px solid #e0e0e0;
                box-shadow: none;
                color: #000;
                max-width: 158px;
                padding-left: 30px;
                border-radius: 6px;
                position: relative;
              }
              .el-input__suffix {
                background: #0a5da6;
                border-radius: 0 5px 5px 0;
                right: 0;
                height: 97%;
              }
            }
            .search-icon {
              position: absolute;
              top: 17px;
              left: 7px;
              bottom: 199px;
              width: 20px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
          .search-accession {
            position: relative;
            .el-input {
              .el-input__inner {
                min-height: 35px;
                border-radius: 5px;
                padding-right: 20px;
                height: 35px;
              }
            }
            .search-icon {
              position: absolute;
              right: 5px;
              top: 7px;
              width: 20px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
        }
      }
    }
  }
  .case-creation__card {
    .edit-view {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .view-cases {
      .el-input__inner {
        height: 30px;
      }
      .value {
        color: #0a2342;
        font-size: 13px;
        font-weight: 500;
      }
    }

    .case-creation__heading {
      .btn {
        min-height: 30px;
        .edit-icon {
          display: flex;
          align-items: center;
          margin-right: 10px;
          p {
            color: #828282;
          }
        }
        margin: 0;
        padding: 0;
        border: none;
        img {
          margin-right: 6px;
          width: 15px;
          height: 15px;
        }
        &:focus {
          background-color: #fff;
        }
        &:hover {
          background-color: #fff;
        }
      }
    }
  }
  .case-creation__footer {
    .look-up-button {
      background: #273480;
      border-radius: 5px;
      color: #ffffff;
      font-weight: 600;
      padding: 8px 19px 8px 19px;
      min-height: 20px;
    }
  }
}
.btn-review-sample {
  background: #f6a623;
  border: none;
  color: #fff;
  font-weight: 600;
  &:hover {
    background: #e0951b;
    color: #fff;
  }
}
.sample-pending-banner {
  margin-bottom: 8px;
  .sample-pending-alert {
    background: #fff8e1;
    border: 1px solid #f6a623;
    border-left: 4px solid #f6a623;
    border-radius: 6px;
    padding: 10px 16px;
    display: flex;
    align-items: center;
    gap: 10px;
    color: #7a4f00;
    font-size: 13px;
    font-weight: 500;
    i {
      font-size: 16px;
      color: #f6a623;
      flex-shrink: 0;
    }
  }
}
.previously-collected-banner {
  margin-bottom: 8px;
  .previously-collected-card {
    background: #fff8e1;
    border: 1px solid #f6dc8e;
    border-radius: 6px;
    overflow: hidden;
  }
  .previously-collected-header {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 16px;
    i {
      font-size: 18px;
      color: #f6a623;
      flex-shrink: 0;
    }
    .previously-collected-heading {
      display: flex;
      align-items: center;
      gap: 8px;
      flex-wrap: wrap;
      h4 {
        margin: 0;
        font-size: 14px;
        font-weight: 700;
        color: #3d3d3d;
      }
      span {
        font-size: 12px;
        color: #8a6d3b;
      }
    }
  }
  .previously-collected-table {
    width: 100%;
    border-collapse: collapse;
    background: #fff;
    th,
    td {
      text-align: left;
      padding: 10px 16px;
      font-size: 13px;
      color: #333;
    }
    thead {
      tr {
        background: #eef1f6;
      }
      th {
        font-weight: 700;
        color: #333;
      }
    }
    tbody tr:not(:last-child) {
      border-bottom: 1px solid #eef1f6;
    }
    .tube-chip {
      display: inline-block;
      background: #eef1f6;
      border-radius: 4px;
      padding: 2px 8px;
      margin: 2px 4px 2px 0;
      font-size: 12px;
      color: #333;
    }
    .tube-chip-item {
      display: inline-flex;
      align-items: center;
      flex-wrap: wrap;
      margin: 2px 4px 2px 0;
      .tube-chip {
        margin: 0 6px 0 0;
      }
    }
    .tube-accession-info {
      font-size: 11px;
      color: #7a4f00;
      background: #fff3d6;
      border: 1px solid #f0d999;
      border-radius: 4px;
      padding: 1px 6px;
      white-space: nowrap;
    }
    .view-order-btn {
      background: #f1f3f8;
      border: none;
      color: #333;
      font-size: 12px;
      font-weight: 600;
    }
  }
}
.order-status-reason {
  margin-bottom: 5px;
  .bg-white {
    background: #fff;
    padding: 10px;
    border-radius: 6.40567px;
  }
  ul {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    li {
      position: relative;
      &:not(:last-child) {
        p {
          &:after {
            content: ",";
          }
          color: #333;
        }
      }
      .reason-heading {
        text-transform: uppercase;
        color: #333;
        margin-right: 0;
        font-size: 13px;
        color: #f24a55;
      }
      p {
        font-size: 13px;
        font-weight: 500;
        margin: 0;
        line-height: 1.5;
      }

      &:not(:last-child) {
        margin-right: 5px;
      }
    }
  }
}
.case-status {
  height: 70px;
  display: flex;
  align-items: center;
  margin-bottom: 0;
  justify-content: space-between;
  li {
    button {
      cursor: default;
    }
  }
}
.navbarComponent.order-view-navbar {
  height: auto !important;
  .case-status {
    height: auto;
    min-height: 70px;
    padding: 10px 0;
  }
}
.order-header-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px 24px;
  width: 100%;

  ul {
    flex-wrap: wrap;
    row-gap: 8px;
  }

  .order-header-left {
    flex: 0 0 auto;

    & + .order-header-accessions {
      padding-left: 24px;
      border-left: 1px solid #dcdfe6;
    }
  }

  .order-header-accessions {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1 1 auto;
    min-width: 0;
    justify-content: flex-start;

    .name {
      white-space: nowrap;
      margin: 0;
      font-size: 15px;
      font-weight: 500;
      color: #000;
    }

    .accession-list {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      min-width: 0;
    }

    .el-button.accession-btn {
      margin: 0;
      min-height: auto;
      padding: 5px 15px;
      font-size: 13px;
      cursor: pointer;
      background-color: #4bb543;
      border: none;
      color: #fff;
      &:hover,
      &:focus {
        background-color: #3f9a38;
        color: #fff;
      }
    }
  }

  .order-header-right {
    flex: 0 0 auto;
    margin-left: auto;

    ul li .el-button {
      cursor: pointer;
    }
  }
}
.emr-issues-inline {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
  margin-top: 6px;
  margin-left: 0;
  .emr-issue-tag {
    font-size: 11px;
    font-weight: 500;
    color: #e6a23c;
    background: #fdf6ec;
    border: 1px solid #f5dab1;
    border-radius: 4px;
    padding: 2px 6px;
    white-space: nowrap;
    i { margin-right: 3px; }
  }
}
.collected-tubes-section {
  background: #fff;
  border: 1.5px solid #e4eaf6;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(39,52,128,0.07);

  .collected-section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: linear-gradient(90deg, #273480 0%, #3b4fa8 100%);
    padding: 12px 20px;
    .collected-section-title {
      display: flex;
      align-items: center;
      gap: 8px;
      color: #fff;
      font-size: 13px;
      font-weight: 700;
      letter-spacing: 0.8px;
      .phlebio-icon {
        width: 22px;
        height: 22px;
        object-fit: contain;
        flex-shrink: 0;
        filter: brightness(0) invert(1);
      }
    }
    .collected-meta {
      display: flex;
      align-items: center;
      gap: 8px;
      .meta-chip {
        display: inline-flex;
        align-items: center;
        font-size: 11px;
        font-weight: 600;
        border-radius: 20px;
        padding: 3px 12px;
        &.fasting {
          background: rgba(250,204,21,0.2);
          color: #fbbf24;
          border: 1px solid rgba(251,191,36,0.4);
        }
        &.technician {
          background: rgba(255,255,255,0.15);
          color: #fff;
          border: 1px solid rgba(255,255,255,0.3);
          strong { font-weight: 700; }
        }
      }
    }
  }

  .collected-tubes-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    padding: 20px 20px 16px;
    background: #f8faff;
    .tube-card {
      display: flex;
      flex-direction: column;
      align-items: center;
      background: #fff;
      border: 1.5px solid #e4eaf6;
      border-radius: 12px;
      padding: 16px 20px 12px;
      min-width: 100px;
      position: relative;
      box-shadow: 0 1px 6px rgba(39,52,128,0.06);
      transition: box-shadow 0.2s;
      &:hover {
        box-shadow: 0 4px 16px rgba(39,52,128,0.13);
      }
      .tube-count {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: #273480;
        color: #fff;
        font-size: 18px;
        font-weight: 700;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 8px;
        box-shadow: 0 2px 8px rgba(39,52,128,0.25);
      }
      .tube-label {
        font-size: 10px;
        font-weight: 700;
        color: #273480;
        text-align: center;
        text-transform: uppercase;
        letter-spacing: 0.4px;
        line-height: 1.3;
        max-width: 80px;
      }
    }
  }

  .collected-tests-row {
    padding: 12px 20px;
    border-top: 1px solid #e4eaf6;
    display: flex;
    align-items: flex-start;
    gap: 10px;
    flex-wrap: wrap;
    .collected-tests-label {
      font-size: 11px;
      font-weight: 700;
      color: #273480;
      white-space: nowrap;
      margin-top: 2px;
      text-transform: uppercase;
      letter-spacing: 0.4px;
    }
    .collected-tests-list {
      display: flex;
      flex-wrap: wrap;
      gap: 6px;
    }
    .collected-test-chip {
      background: #eef2ff;
      color: #3b4fa8;
      font-size: 11px;
      font-weight: 500;
      border-radius: 20px;
      padding: 3px 10px;
      border: 1px solid #c7d2fe;
    }
  }
}

</style>
